import React from 'react';
import { Block } from '@guryou/html-components';
const HtmlAudioPlayer = ({
  src
}) => {
  return /*#__PURE__*/React.createElement(Block, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement("audio", {
    controls: true
  }, /*#__PURE__*/React.createElement("source", {
    src: src,
    type: "audio/mpeg"
  }), "Your browser does not support the audio tag."));
};
export { HtmlAudioPlayer };